import { render } from "./ChosenPlanInfo.vue?vue&type=template&id=3aaa85d1&scoped=true&ts=true"
import script from "./ChosenPlanInfo.vue?vue&type=script&lang=ts"
export * from "./ChosenPlanInfo.vue?vue&type=script&lang=ts"

import "./ChosenPlanInfo.vue?vue&type=style&index=0&id=3aaa85d1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaa85d1"]])

export default __exports__